import React from 'react';
import { Container, Row, View } from '@amzn/stencil-react-components/layout';
import { Label } from '@amzn/stencil-react-components/text';
import LanguageSelectFlyout from 'src/components/common/LanguageSelectFlyout';
import { recordEvent } from 'src/analytics/amplify'
import GetHelpFlyout from './GetHelpFlyout';
import TranslationKeys from 'src/constants/translation-keys';
import { useTranslation } from "react-i18next";
import { token } from '@amzn/stencil-design-tokens/js/web/utils';
export default function Footer() {

  const { t } = useTranslation();

  function handleFlyoutClick(FlyoutType: string) {
    recordEvent({
      name: `Footer.${FlyoutType}Flyout.Click`,
      immediate: true
    });
  }

  return (
    <Container data-testid='common-footer'>
        <Row alignItems="center" justifyContent="center">
          <LanguageSelectFlyout />
          <Label textAlign="center" aria-hidden={true}
                 style={{marginLeft: '16px', marginRight: '16px', color: token('color.link.primary-default')}}>|</Label>
          <View onClick={() => handleFlyoutClick('GetHelp')}>
            <GetHelpFlyout buttonText={t(TranslationKeys.FOOTER.GET_HELP)} />
          </View>
        </Row>
    </Container>
  );
}
